export default ({...props}) => {
    const {panelHighlight, size, space} = props.theme
    return `
        display: flex;
        justify-content: space-between;
        flex-flow: row wrap;
        gap: ${space(1.25)}px;
        padding: ${space(2.5)}px;

        & > div.address-details-wrapper > p, 
        & > div.notification-details-wrapper > p {
            margin-bottom: ${space(0.4)}px;
        }

        & .label-wrapper {
            display: flex;
            gap: ${space(0.625)}px;
            align-items: center;
            margin-bottom: ${space(1.25)}px;

            & > p {
                margin: 0;
                text-transform: uppercase;
            }

            & > p:nth-of-type(2) {
                cursor: pointer;
            }
        }

        & svg {
            width: ${size(2)}px;
            height: ${size(2)}px;
            cursor: pointer;
            & path {
                fill: ${panelHighlight.foreground};
            }
        }

        & > div.notification-details-wrapper > p {
            margin-bottom: ${space(1)}px;
        }

        @media screen and (max-width:480px) {
            flex-flow: column;
            align-items: stretch;

            & div.leaflet-container {
                height: ${size(31.5)}px;
                width: ${space(12.5)}%;
                margin-top: 0;
                margin-bottom: ${space(2)}px;
            }

            & .label-wrapper {
                justify-content: space-between;
            }
        }
    `
}
